import axios from '@/axios-mock'
import browser from '@beastshop/browser'
import util from 'util'

const is_app = browser.app()

const PRODUCT_FETCH_DEBOUNCE_INTERVAL = 100
const _productFetchQueue = []
const _productCallbacks = []

let _productTimer = null
const _productCache = {}

let isError = false

export function getActivity (codes, callback) {
  codes = util.isArray(codes)
    ? codes
    : [codes]

  const not_fetched = _filterProductIds(codes)
  let returned

  function done_once (err, data) {
    if (!returned) {
      returned = true
      callback(err, data)
    }
  }

  function done () {
    const products = {}
    codes.forEach((code) => {
      products[code] = _productCache[code] || null
    })
    done_once(isError, products)
  }

  if (!not_fetched.length) {
    return done()
  }

  _registerQueue(codes, () => {
    done()
  })
}


function _registerQueue (codes, callback) {
  codes.forEach((code) => {
    _productFetchQueue.push(code)
  })

  _productCallbacks.push(callback)

  if (_productTimer) {
    clearTimeout(_productTimer)
  }

  _productTimer = setTimeout(() => {
    _getProductData()

  }, PRODUCT_FETCH_DEBOUNCE_INTERVAL)
}


function _filterProductIds (codes) {
  return codes.filter((code) => {
    return !(code in _productCache)
  })
}

function getDomain(){
  if (is_app) {
    return ''
  }
  switch(window.location.hostname){
    case 'static.thebeastshop.com':
      return '//api.thebeastshop.com'
      break;
    case 'scm.thebeastshop.com':
      return '//api.thebeastshop.com'
      break;
    case 'static-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com'
      break;
    case 'scm-test.thebeastshop.com':
      return 'http://api-test.thebeastshop.com'
      break;
    default:
      return '//api.thebeastshop.com'
  }
}


const MAX_PRODUCTS = 50

function _getProductData () {
  // clone
  const callbacks = [].concat(_productCallbacks)
  const codes = _filterProductIds(_productFetchQueue)
  _productCallbacks.length = 0
  _productFetchQueue.length = 0

  const pieces = Math.ceil(codes.length / MAX_PRODUCTS)
  let counter = 0
  let i = 0

  do {
    _fetchProducts(codes.slice(i * MAX_PRODUCTS, (i + 1) * MAX_PRODUCTS))
    .then(data => {
      done(data)
    })
    .catch(err => {
      done()
    })
  } while (++ i < pieces)

  function done () {
    if (++ counter === pieces) {
      run_callbacks()
    }
  }

  function run_callbacks () {
    callbacks.forEach((callback) => {
      callback()
    })
  }
}


function _fetchProducts (codes) {
  return axios({
    url: `/app/product/simple/campaign`,
    json: codes,
    method: 'POST'
  })
  .then(({
    code,
    data
  }) => {
    if (code == '500') {
      isError = true
    }
    data.forEach((activity) => {
      if (!activity) {
        return
      }

      _productCache[activity.code] = activity
    })
    return Promise.resolve(data)
  })
  .catch(err => {
    isError = true
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./static/product-activity/index.js